import React from 'react'
import { Section, Heading } from 'components'
import { graphql } from 'gatsby'

const UpdatesSingle = ({ data }) => {
  const post = data.wpProductUpdate
  return (
    <Section>
      <Heading level="1">{post.title}</Heading>
      <div dangerouslySetInnerHTML={{ __html: post.content }} />
    </Section>
  )
}

export const query = graphql`
  query GET_UPDATE($id: String!) {
    wpProductUpdate(id: { eq: $id }) {
      title
      content
      date(formatString: "MMMM DD, YYYY")
    }
  }
`
export default UpdatesSingle
